import React from 'react';
import { LumaWordmark } from '../LumaLogo';

const navLinks = [
  { label: 'Home', href: '#hero' },
  { label: 'Experience', href: '#experience' },
  { label: 'Events', href: '#events' },
  { label: 'Gallery', href: '#gallery' },
  { label: 'Book Now', href: '#booking' },
];

const scrollTo = (href) => {
  const el = document.querySelector(href);
  if (el) el.scrollIntoView({ behavior: 'smooth' });
};

export const Footer = () => (
  <footer
    id="footer"
    data-testid="footer"
    className="relative py-16 lg:py-20 px-6 overflow-hidden"
    style={{ background: '#060606', borderTop: '1px solid rgba(255,255,255,0.05)' }}
  >
    {/* Top divider glow */}
    <div
      className="absolute top-0 left-1/2 -translate-x-1/2 w-64 h-px pointer-events-none"
      style={{ background: 'linear-gradient(to right, transparent, rgba(139,92,246,0.4), transparent)' }}
    />

    <div className="max-w-7xl mx-auto">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
        {/* Brand */}
        <div className="md:col-span-1">
          <button onClick={() => scrollTo('#hero')} className="mb-4 block" data-testid="footer-logo">
            <LumaWordmark size="sm" />
          </button>
          <p className="font-manrope text-sm text-white/35 leading-relaxed max-w-xs mt-4">
            Where light, music, and movement become one experience.
          </p>
        </div>

        {/* Navigation */}
        <div>
          <p className="text-xs font-manrope tracking-[0.25em] uppercase text-white/30 mb-5">Navigation</p>
          <ul className="space-y-3">
            {navLinks.map((link) => (
              <li key={link.label}>
                <button
                  data-testid={`footer-link-${link.label.toLowerCase().replace(' ', '-')}`}
                  onClick={() => scrollTo(link.href)}
                  className="font-manrope text-sm text-white/50 hover:text-white transition-colors duration-200"
                >
                  {link.label}
                </button>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact */}
        <div>
          <p className="text-xs font-manrope tracking-[0.25em] uppercase text-white/30 mb-5">Contact</p>
          <ul className="space-y-3">
            <li>
              <a
                data-testid="footer-email"
                href="mailto:book@enterluma.com"
                className="font-manrope text-sm text-white/50 hover:text-luma-purple transition-colors duration-200"
              >
                book@enterluma.com
              </a>
            </li>
            <li>
              <a
                data-testid="footer-instagram"
                href="#"
                className="font-manrope text-sm text-white/50 hover:text-luma-purple transition-colors duration-200"
              >
                @luma.experience
              </a>
            </li>
          </ul>
        </div>
      </div>

      {/* Bottom bar */}
      <div
        className="pt-8 flex flex-col sm:flex-row items-center justify-between gap-4"
        style={{ borderTop: '1px solid rgba(255,255,255,0.05)' }}
        data-testid="footer-bottom"
      >
        <p className="font-manrope text-xs text-white/20">
          © {new Date().getFullYear()} Luma. All rights reserved.
        </p>
        <p className="font-manrope text-xs text-white/20 tracking-[0.2em] uppercase">
          Immersive LED Experiences
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
